import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "../styles/Profile.css";

const Profile = () => {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    address: ""
  });

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [orders, setOrders] = useState([]);
  const [ordersError, setOrdersError] = useState(false);

  const { user } = useAuth();
  const token = user?.token;
  const navigate = useNavigate(); // 👉 importar esto

   // 👉 Redirigir si no hay usuario
  useEffect(() => {
  if (!loading && !user) {
    navigate("/login");
  }
}, [user, loading, navigate]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/orders/mine`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          setOrdersError(true);
          return;
        }

        const data = await res.json();
        setOrders(data);
      } catch (err) {
        console.error("Error al cargar órdenes:", err);
        setOrdersError(true);
      }
    };

    if (token) fetchOrders();
  }, [token]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/auth/profile`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!res.ok) {
          console.error("❌ Error al autenticar");
          return;
        }

        const data = await res.json();
        setProfile(data);
      } catch (err) {
        console.error("Error al cargar perfil:", err);
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchProfile();
  }, [token]);

  const handleChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/auth/profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          name: profile.name,
          phone: profile.phone,
          address: profile.address
        })
      });

      const result = await res.json();
      if (res.ok) {
        setMessage("✅ Perfil actualizado con éxito.");
      } else {
        setMessage(result.error || "Error al actualizar perfil.");
      }
    } catch (err) {
      console.error("Error actualizando perfil:", err);
      setMessage("Error de red.");
    }
  };

  if (loading) return <p>Cargando perfil...</p>;

  return (
    <div className="profile-container">
      
      <form onSubmit={handleSubmit} className="profile-form">
        <label>Nombre</label>
        <input
          type="text"
          name="name"
          value={profile.name}
          onChange={handleChange}
          required
        />

        <label>Email</label>
        <input type="email" value={profile.email} disabled />

        <label>Teléfono</label>
        <input
          type="tel"
          name="phone"
          value={profile.phone || ""}
          onChange={handleChange}
        />

        <label>Dirección</label>
        <input
          type="text"
          name="address"
          value={profile.address || ""}
          onChange={handleChange}
        />

        <button type="submit">Guardar cambios</button>
      </form>
      {message && <p className="profile-message">{message}</p>}

      <h3>Mis órdenes</h3>
      {ordersError ? (
        <p>No se pudo cargar tus órdenes. Asegúrate de haber iniciado sesión.</p>
      ) : Array.isArray(orders) && orders.length === 0 ? (
        <p>No tienes órdenes registradas.</p>
      ) : Array.isArray(orders) ? (
        <ul className="orders-list">
          {orders.map((order) => (
            <li key={order.id} className="order-item">
              <p><strong>Fecha:</strong> {new Date(order.created_at).toLocaleString()}</p>
              <p><strong>Método:</strong> {order.payment_method}</p>
              <p><strong>Total:</strong> ${order.total.toFixed(2)}</p>
              <p><strong>Estado:</strong> {order.status}</p>
              <ul>
                {order.items.map((item, idx) => (
                  <li key={idx}>
                    {item.product_name} x{item.quantity} – ${item.price}
                  </li>
                ))}
              </ul>
              <hr />
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default Profile;
